var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-breadcrumbs',{staticClass:"py-2",attrs:{"items":_vm.breadCrumbList},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{attrs:{"disabled":item.disabled,"to":item.href,"exact":item.exact}},[_vm._v(" "+_vm._s(_vm.getBreadcrumbText(item.text))+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }